import { get, getViaAuth, postViaAuth, responseValidator } from '../../apis/api';
import { API } from '../../apis';
import { message } from 'antd';
import { Dispatch, SetStateAction } from 'react';
import toast from 'react-hot-toast';
import { SERVER_URL } from '../constants/constants';
import {
    EditMarketCommentBody,
    EditMarketContentBody,
    EditMarketFaqBody,
    Market,
} from 'core/domain/manage-market/manage-market';
import { PaginationList } from 'core/domain';

export async function getAllMarkets(
    setLoading: any,
    setData: any,
    page: number,
    itemsPerPageCount: number,
    query?: string,
) {
    setLoading(true);
    await getViaAuth<PaginationList<Market>>(`${API.market.getAllMarketV2}/${page}/${itemsPerPageCount}${query}`).then((response) => {
        setLoading(false);
        console.log({ marketsResp: response })

        if (responseValidator(response.status) && response) {
            // setData(response.data.data);
            setData(response.value);
        }
    });
}

export const updateMarket = (
    setloader: any,
    setdata: any,
    market: any,
    page: number,
    query: string,
    setisediting?: any,
    setvalue?: any,
) => {
    setloader(true);
    postViaAuth(API.market.edit, market).then((response: any) => {
        setloader(false);
        setisediting && setisediting(false);
        setvalue && setvalue(false);
        if (responseValidator(response.status)) {
            message.success('ارز با موفقیت ویرایش شد');
            getAllMarkets(setloader, setdata, page, 10, query);
        }
    });
};

function base64ToArrayBuffer(base64: any) {
    var binaryString = atob(base64.split(',')[1]);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

export const getMarketContentBySymbol = async (setLoading: any, setData: any, symbol: string = '') => {
    setLoading(true);
    await get(API.marketContent.getMarketContentBySymbolAdmin + `/${symbol}`).then(async (response: any) => {
        let responseData: any = {};
        setLoading(false);
        if (responseValidator(response.status) && response.data) {
            const marketContent = response.data.value?.marketContent ?? {};
            Object.assign(responseData, {
                coinColor: marketContent.coinColor ?? '',
                description1: marketContent.description1 ?? '',
                description2: marketContent.description2 ?? '',
                content: marketContent.content ?? '',
                // 🔹 keep relative paths here
                coin3DImageUrl: marketContent.coin3DImageUrl ?? '',
                heroBackGroundImageUrl: marketContent.heroBackGroundImageUrl ?? '',
                videoEmbed: marketContent.videoEmbed ?? '',
                customScript: marketContent.customScript ?? '',
                metaTitle: marketContent.metaTitle ?? '',
                metaDescription: marketContent.metaDescription ?? '',
                noIndex: marketContent.noIndex ?? false,
                canonicalLink: marketContent.canonicalLink ?? '',
            });

            setData(responseData);
        }
    });
};

export const editMarketContent = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: EditMarketContentBody,
    symbol: string = '',
) => {
    setLoading(true);

    const formData = new FormData();

    data?.description1 && formData.append('description1', data.description1);
    data?.description2 && formData.append('description2', data.description2);
    data?.content && formData.append('content', data.content);

    // 🔹 NEW: send coin 3D image file if user selected one
    if (data.coin3DImageUrlFile && data.coin3DImageUrlFile instanceof File) {
        formData.append('coin3DImageUrl', data.coin3DImageUrlFile);
    }

    data?.coinColor && formData.append('coinColor', data.coinColor);
    data?.videoEmbed && formData.append('videoEmbed', data.videoEmbed);
    data?.customScript && formData.append('customScript', data.customScript);
    data?.metaTitle && formData.append('metaTitle', data.metaTitle);
    data?.metaDescription && formData.append('metaDescription', data.metaDescription);
    formData.append('noIndex', data?.noIndex ? 'true' : 'false');
    data?.canonicalLink && formData.append('canonicalLink', data.canonicalLink);

    // 🔹 NEW: send hero background image file if user selected one
    if (data.heroBackGroundImageUrlFile && data.heroBackGroundImageUrlFile instanceof File) {
        formData.append('heroBackGroundImageUrl', data.heroBackGroundImageUrlFile);
    }

    symbol && formData.append('symbol', symbol);

    const response: any = await postViaAuth(API.marketContent.updateMarketContent, formData, true);
    setLoading(false);
    if (responseValidator(response.status)) {
        toast.success('محتوای ارز با موفقیت ویرایش شد');
    }
};

export const editMarketComments = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: EditMarketCommentBody[],
    symbol: string = '',
) => {
    setLoading(true);
    await postViaAuth(API.marketContent.updateComments, {
        symbol,
        comments: data,
    }).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            toast.success('نظرات ارز با موفقیت ویرایش شد');
        }
    });
};

export const editMarketFaqs = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: EditMarketFaqBody[],
    symbol: string = '',
) => {
    setLoading(true);
    await postViaAuth(API.marketContent.updateFaqs, {
        symbol,
        faqs: data,
    }).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            toast.success('پرسش و پاسخ ها با موفقیت ویرایش شد');
        }
    });
};
